// extracted by mini-css-extract-plugin
export default {"tooltipBlock":"Tooltip_tooltipBlock__0QdQF","tooltipBody":"Tooltip_tooltipBody__jY__D"};